export const defaultUpdateApplication = {
    "application": {
        "occupants": [
            {
                "full_name": "",
                "ssn": "",
                "email": "",
                "home_phone": "",
                "work_phone": "",
                "cell_phone": "",
                "dob": "",
                "status": "",
                "id": ""
            }
        ],
        "move_in": {
            "expected_move_in": "",
            "unit_id": "",
            "floor_plan_id": "",
            "id": ""
        },
        "pets": [
            {
                "name": "",
                "breed": "",
                "type": "",
                "weight": "",
                "id": ""
            }
        ],
        "vehicles": [
            {
                "make_model": "",
                "color": "",
                "license_plate": "",
                "state": "",
                "id": ""
            }
        ],
        "histories": [
            {
                "address": "",
                "landlord_name": "",
                "landlord_phone": "",
                "landlord_email": "",
                "rent": "",
                "residency_length": "",
                "current": "",
                "id": ""
            }
        ],
        "employments": [
            {
                "occupant_index": "",
                "address": "",
                "duration": "",
                "employer": "",
                "phone": "",
                "email": "",
                "supervisor": "",
                "salary": "",
                "current": "",
                "id": ""
            }
        ],
        "income": {
            "salary": "",
            "description": "",
            "present": "",
            "id": ""
        },
        "emergency_contacts": [
            {
                "name": "",
                "phone": "",
                "email": "",
                "relationship": "",
                "id": ""
            }
        ],
        "documents": [
            {
                "type": "",
                "url": ""
            },
            {
                "type": "",
                "url": ""
            }
        ]
    },
    "full": ""
}
